import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid ml-0 mr-1" }
const _hoisted_2 = { class: "flex flex-auto p-input-icon-left p-input-icon-right mb-2" }
const _hoisted_3 = { class: "col-12 grid flex-nowrap" }
const _hoisted_4 = {
  class: "col-fixed",
  style: {"margin-left":"-1.5rem"}
}
const _hoisted_5 = { class: "col-1 text-center" }
const _hoisted_6 = { class: "col-12 grid flex-nowrap" }
const _hoisted_7 = { class: "col-fixed" }
const _hoisted_8 = { class: "col-2" }
const _hoisted_9 = { class: "col-2" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "col-2" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "col-1" }
const _hoisted_19 = { class: "col-4" }
const _hoisted_20 = { class: "pl-4 pr-4 text-wrap" }
const _hoisted_21 = { class: "col-12 grid flex-nowrap" }
const _hoisted_22 = { class: "col-2" }
const _hoisted_23 = { class: "col-2" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "col-2" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "col-1" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "col-1 text-wrap" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { class: "col-1" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "col-2" }
const _hoisted_42 = { class: "text-wrap" }
const _hoisted_43 = { class: "col-12 grid flex-nowrap" }
const _hoisted_44 = { class: "col-1 text-center" }
const _hoisted_45 = { class: "col-12 grid flex-nowrap" }
const _hoisted_46 = { class: "col-fixed email-select" }
const _hoisted_47 = { class: "col-2" }
const _hoisted_48 = { class: "col-2" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "col-2" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "col-1" }
const _hoisted_57 = { class: "col-fixed email-last-sent-header" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "col-1" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { class: "col-2" }
const _hoisted_64 = { class: "text-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_DocumentGeneration = _resolveComponent("DocumentGeneration")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("i", { class: "pi pi-home" }, null, -1)),
        _createVNode(_component_InputText, {
          modelValue: _ctx.filterText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterText) = $event)),
          placeholder: "Email keyword filter.."
        }, null, 8, ["modelValue"]),
        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "pi pi-search" }, null, -1))
      ])
    ]),
    _createVNode(_component_TabView, {
      activeIndex: _ctx.activeTab,
      "onUpdate:activeIndex": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTab) = $event)),
      onTabChange: _ctx.onTabChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanel, null, {
          header: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createElementVNode("i", { class: "pi pi-envelope" }, null, -1),
            _createTextVNode("  ", -1),
            _createElementVNode("span", null, "Email Automation", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_DataView, {
                value: _ctx.filteredEmailList,
                datakey: "propertyId",
                paginator: true,
                rows: 50,
                scrollable: true,
                stripedRows: "",
                class: "p-datatable-sm property-service-table",
                paginatorTemplate: _ctx.paginatorTemplate,
                rowsPerPageOptions: [10,20,50,100,200],
                responsiveLayout: "scroll",
                alwaysShowPaginator: false,
                onPage: _ctx.onPageChange,
                currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _withDirectives(_createVNode(_component_Checkbox, {
                        modelValue: _ctx.selectAllCheckbox,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectAllCheckbox) = $event)),
                        binary: true
                      }, null, 8, ["modelValue"]), [
                        [
                          _directive_tooltip,
                          'Select all records on the current page',
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-2" }, "Property", -1)),
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-2" }, "Customer", -1)),
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-2" }, "Recipient Company", -1)),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.dueDateColumnHeader), 1),
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-1" }, "Template Type", -1)),
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-4" }, [
                      _createElementVNode("div", { class: "ml-6" }, "Recipients")
                    ], -1))
                  ])
                ]),
                list: _withCtx(({data}) => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_Checkbox, {
                        modelValue: data.isSelectedOnRecommended,
                        "onUpdate:modelValue": ($event: any) => ((data.isSelectedOnRecommended) = $event),
                        binary: true
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_router_link, {
                        to: { name: 'PropertyDetails', params: { propertyId: data.propertyId }}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.propertyId) + " - " + _toDisplayString(data.propertyName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      (data.customerCompanyId)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: 'CompanyDetails', params: { companyId: data.customerCompanyId }}
                          }, {
                            default: _withCtx(() => [
                              (data.customerCompanyName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(data.customerCompanyName), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_11, "ID: " + _toDisplayString(data.customerCompanyId), 1))
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_12, "Unknown"))
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      (data.recipientCompanyId)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_router_link, {
                              to: { name: 'CompanyDetails', params: { companyId: data.recipientCompanyId }}
                            }, {
                              default: _withCtx(() => [
                                (data.recipientCompanyName)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(data.recipientCompanyName), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_15, "ID: " + _toDisplayString(data.recipientCompanyId), 1))
                              ]),
                              _: 2
                            }, 1032, ["to"]),
                            _withDirectives((_openBlock(), _createElementBlock("a", {
                              class: "ml-1",
                              onClick: ($event: any) => (_ctx.onEnvelopeClick(data))
                            }, [...(_cache[14] || (_cache[14] = [
                              _createElementVNode("i", { class: "pi pi-envelope" }, null, -1)
                            ]))], 8, _hoisted_16)), [
                              [
                                _directive_tooltip,
                                'Review Email',
                                void 0,
                                { top: true }
                              ]
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock("span", _hoisted_17, "Unknown"))
                    ]),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formattedDate(data.nextDue)), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-1", _ctx.getStyleForTemplateName(data.emailContentTemplateName)])
                    }, _toDisplayString(_ctx.getEmailTemplateTypeFriendlyName(data.emailContentTemplateName)), 3),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createTextVNode(_toDisplayString(_ctx.getFormattedRecipients(data.recipients)) + " ", 1),
                        (data.ccRecipients)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" CC: " + _toDisplayString(_ctx.getFormattedRecipients(data.ccRecipients)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["value", "paginatorTemplate", "onPage"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          header: _withCtx(() => [...(_cache[16] || (_cache[16] = [
            _createElementVNode("i", { class: "pi pi-send" }, null, -1),
            _createTextVNode("  ", -1),
            _createElementVNode("span", null, "Sent", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_DataView, {
                value: _ctx.filteredEmailList,
                datakey: "propertyId",
                paginator: true,
                rows: 50,
                scrollable: true,
                stripedRows: "",
                class: "p-datatable-sm property-service-table",
                paginatorTemplate: _ctx.paginatorTemplate,
                rowsPerPageOptions: [10,20,50,100,200],
                responsiveLayout: "scroll",
                alwaysShowPaginator: false,
                currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
              }, {
                header: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("div", { class: "col-12 grid flex-nowrap" }, [
                    _createElementVNode("div", { class: "col-2" }, "Property"),
                    _createElementVNode("div", { class: "col-2" }, "Customer"),
                    _createElementVNode("div", { class: "col-2" }, "Recipient Company"),
                    _createElementVNode("div", { class: "col-1" }, "Status"),
                    _createElementVNode("div", { class: "col-1" }, "Generated By"),
                    _createElementVNode("div", { class: "col-1" }, "Template Type"),
                    _createElementVNode("div", { class: "col-1" }, "When Last Attempted"),
                    _createElementVNode("div", { class: "col-2" }, [
                      _createElementVNode("div", { class: "ml-5" }, "Recipients")
                    ])
                  ], -1)
                ]))]),
                list: _withCtx(({data}) => [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_router_link, {
                        to: { name: 'PropertyDetails', params: { propertyId: data.propertyId }}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.propertyId) + " - " + _toDisplayString(data.propertyName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      (data.customerCompanyId)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: 'CompanyDetails', params: { companyId: data.customerCompanyId }}
                          }, {
                            default: _withCtx(() => [
                              (data.customerCompanyName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(data.customerCompanyName), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_25, "ID: " + _toDisplayString(data.customerCompanyId), 1))
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_26, "Unknown"))
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      (data.recipientCompanyId)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: 'CompanyDetails', params: { companyId: data.recipientCompanyId }}
                          }, {
                            default: _withCtx(() => [
                              (data.recipientCompanyName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(data.recipientCompanyName), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_29, "ID: " + _toDisplayString(data.recipientCompanyId), 1))
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_30, "Unknown"))
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      (_ctx.isQueued(data.status))
                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_32, [
                            _createTextVNode(_toDisplayString(data.status), 1)
                          ])), [
                            [
                              _directive_tooltip,
                              'Triggered on: ' + _ctx.formattedDateTime(data.lstSupEmailTrg),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_33, [
                            _createTextVNode(_toDisplayString(data.status), 1)
                          ])), [
                            [
                              _directive_tooltip,
                              'Last Attempted: ' + _ctx.formattedDateTime(data.lstSupEmailSent),
                              void 0,
                              { top: true }
                            ]
                          ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      (data.generatedBy)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(data.generatedBy), 1))
                        : (_ctx.isQueued(data.status))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, "-"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_37, "Unknown"))
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-1", _ctx.getStyleForTemplateName(data.emailContentTemplateName)])
                    }, _toDisplayString(_ctx.getEmailTemplateTypeFriendlyName(data.emailContentTemplateName)), 3),
                    _createElementVNode("div", _hoisted_38, [
                      (data.lstSupEmailSent)
                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_39, [
                            _createTextVNode(_toDisplayString(_ctx.formattedDate(data.lstSupEmailSent)), 1)
                          ])), [
                            [
                              _directive_tooltip,
                              'Last Attempted: ' + _ctx.formattedDateTime(data.lstSupEmailSent),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : (_openBlock(), _createElementBlock("span", _hoisted_40, "Never"))
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createTextVNode(_toDisplayString(_ctx.getFormattedRecipients(data.recipients)) + " ", 1),
                        (data.ccRecipients)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" CC: " + _toDisplayString(_ctx.getFormattedRecipients(data.ccRecipients)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["value", "paginatorTemplate"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          header: _withCtx(() => [...(_cache[19] || (_cache[19] = [
            _createElementVNode("i", { class: "pi pi-pause" }, null, -1),
            _createTextVNode("  ", -1),
            _createElementVNode("span", null, "Snoozed / Held", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_DataView, {
                value: _ctx.filteredEmailList,
                datakey: "propertyId",
                paginator: true,
                rows: 50,
                scrollable: true,
                stripedRows: "",
                class: "p-datatable-sm property-service-table",
                paginatorTemplate: _ctx.paginatorTemplate,
                rowsPerPageOptions: [10,20,50,100,200],
                responsiveLayout: "scroll",
                alwaysShowPaginator: false,
                currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_43, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-fixed email-select" }, null, -1)),
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-2" }, "Property", -1)),
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-2" }, "Customer", -1)),
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-2" }, "Recipient Company", -1)),
                    _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.dueDateColumnHeader), 1),
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-1" }, "Template Type", -1)),
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "col-fixed email-last-sent-header" }, "When Last Sent", -1)),
                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "col-1" }, [
                      _createElementVNode("div", { class: "ml-5" }, "Reason")
                    ], -1)),
                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col-fixed email-recipients" }, [
                      _createElementVNode("div", { class: "ml-5" }, "Recipients")
                    ], -1))
                  ])
                ]),
                list: _withCtx(({data}) => [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      (_ctx.isOnlySnoozed(data.reason))
                        ? (_openBlock(), _createBlock(_component_Checkbox, {
                            key: 0,
                            modelValue: data.isSelectedOnSnoozed,
                            "onUpdate:modelValue": ($event: any) => ((data.isSelectedOnSnoozed) = $event),
                            binary: true
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _withDirectives((_openBlock(), _createBlock(_component_Checkbox, {
                            key: 1,
                            modelValue: data.isSelectedOnSnoozed,
                            "onUpdate:modelValue": ($event: any) => ((data.isSelectedOnSnoozed) = $event),
                            binary: true,
                            disabled: true
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])), [
                            [
                              _directive_tooltip,
                              'You can only resume emails that were snoozed',
                              void 0,
                              { top: true }
                            ]
                          ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_router_link, {
                        to: { name: 'PropertyDetails', params: { propertyId: data.propertyId }}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.propertyId) + " - " + _toDisplayString(data.propertyName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      (data.customerCompanyId)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: 'CompanyDetails', params: { companyId: data.customerCompanyId }}
                          }, {
                            default: _withCtx(() => [
                              (data.customerCompanyName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(data.customerCompanyName), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_50, "ID: " + _toDisplayString(data.customerCompanyId), 1))
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_51, "Unknown"))
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      (data.recipientCompanyId)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: 'CompanyDetails', params: { companyId: data.recipientCompanyId }}
                          }, {
                            default: _withCtx(() => [
                              (data.recipientCompanyName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(data.recipientCompanyName), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_54, "ID: " + _toDisplayString(data.recipientCompanyId), 1))
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_55, "Unknown"))
                    ]),
                    _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.formattedDate(data.nextDue)), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-1", _ctx.getStyleForTemplateName(data.emailContentTemplateName)])
                    }, _toDisplayString(_ctx.getEmailTemplateTypeFriendlyName(data.emailContentTemplateName)), 3),
                    _createElementVNode("div", _hoisted_57, [
                      (data.lstSupEmailSent)
                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_58, [
                            _createTextVNode(_toDisplayString(_ctx.formattedDate(data.lstSupEmailSent)), 1)
                          ])), [
                            [
                              _directive_tooltip,
                              'Last Email Sent: ' +_ctx.formattedDateTime(data.lstSupEmailSent),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : (_openBlock(), _createElementBlock("span", _hoisted_59, "Never"))
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      (_ctx.isSnoozed(data.reason))
                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_61, [
                            _createTextVNode(_toDisplayString(data.reason), 1)
                          ])), [
                            [
                              _directive_tooltip,
                              'Snoozed until: ' + _ctx.formattedDateTime(data.snoozedTill),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(data.reason), 1))
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createTextVNode(_toDisplayString(data.recipients) + " ", 1),
                        (data.ccRecipients)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" CC: " + _toDisplayString(_ctx.getFormattedRecipients(data.ccRecipients)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["value", "paginatorTemplate"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeIndex", "onTabChange"]),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.activeTab == 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_Button, {
                  class: _normalizeClass(["sticky-button btn-fixed-width", _ctx.isBulkSendingDisabled ? 'disabled-feature':'']),
                  icon: "pi pi-send",
                  label: "Send",
                  onClick: _ctx.sendEmailsConfirmation,
                  disabled: _ctx.selectedOnRecommendedEmailCount == 0 || _ctx.isBulkSendingDisabled 
                }, null, 8, ["onClick", "disabled", "class"]),
                _createVNode(_component_SplitButton, {
                  ref: "snoozeButton",
                  model: _ctx.snoozeOptions,
                  class: "sticky-button btn-fixed-width",
                  icon: "pi pi-pause",
                  label: "Snooze",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.snoozeEmailsConfirmation(7))),
                  disabled: _ctx.selectedOnRecommendedEmailCount == 0
                }, null, 8, ["model", "disabled"])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.activeTab == 1)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: _normalizeClass(["sticky-button btn-fixed-width", _ctx.isBulkSendingDisabled ? 'disabled-feature':'']),
                icon: "pi pi-forward",
                label: "Trigger Email Automation",
                onClick: _ctx.triggerEmailSend,
                disabled: _ctx.getQueuedEmails.length == 0 || !_ctx.triggerEmailAutomationEnabled || _ctx.isBulkSendingDisabled
              }, null, 8, ["onClick", "disabled", "class"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab == 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_Button, {
                  class: "sticky-button btn-fixed-width",
                  icon: "pi pi-play",
                  label: "Resume",
                  onClick: _ctx.resumeEmailsConfirmation,
                  disabled: _ctx.selectedOnSnoozedEmailCount == 0
                }, null, 8, ["onClick", "disabled"]),
                _createVNode(_component_Button, {
                  class: _normalizeClass(["sticky-button btn-fixed-width", _ctx.isBulkSendingDisabled ? 'disabled-feature':'']),
                  icon: "pi pi-send",
                  label: "Resume & Send",
                  onClick: _ctx.resumeAndSendEmailsConfirmation,
                  disabled: _ctx.selectedOnSnoozedEmailCount == 0 || _ctx.isBulkSendingDisabled
                }, null, 8, ["onClick", "disabled", "class"])
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.showDocumentGenerationComponent)
      ? (_openBlock(), _createBlock(_component_DocumentGeneration, {
          key: 1,
          selectedDocumentTemplate: _ctx.selectedDocumentTemplate,
          selectedEmailTemplate: _ctx.selectedEmailTemplate,
          propertyData: _ctx.propertyData,
          toggledService: _ctx.toggledService,
          initialActiveTab: _ctx.documentGenerationActiveTab,
          isEmailSendingDisabled: false,
          recipientCompanyId: _ctx.envelopeClickRecipientCompanyId,
          onUpdateShowDocumentGenerationComponent: _cache[4] || (_cache[4] = ($event: any) => {_ctx.showDocumentGenerationComponent = $event;}),
          onReloadData: _ctx.loadEmailData,
          onRefreshSentEmails: _cache[5] || (_cache[5] = ($event: any) => (_ctx.refreshSentEmails = $event))
        }, null, 8, ["selectedDocumentTemplate", "selectedEmailTemplate", "propertyData", "toggledService", "initialActiveTab", "recipientCompanyId", "onReloadData"]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}